import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './FullScreenModalLayoutHeader.st.css';
import { FullScreenModalLayoutHeaderProps } from '../../FullScreenModalLayout.types';
import { DATA_HOOKS } from '../../FullScreenModalLayout.constants';

const FullScreenModalLayoutHeader = ({
  children,
  startNode,
  endNode,
  dataHook,
  className,
}: FullScreenModalLayoutHeaderProps) => {
  return (
    <div
      data-hook={dataHook || DATA_HOOKS.fullScreenModalLayoutHeader}
      className={st(classes.root, {}, className)}
    >
      {startNode && <div className={classes.startNode}>{startNode}</div>}
      <div className={classes.title}>{children}</div>
      {endNode && <div className={classes.endNode}>{endNode}</div>}
    </div>
  );
};

FullScreenModalLayoutHeader.displayName = 'FullScreenModalLayout.Header';

FullScreenModalLayoutHeader.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook: PropTypes.string,
  /**
   * Allows you to apply a CSS class to the component's root element.
   * @internal
   **/
  className: PropTypes.string,
  /** The main title node */
  children: PropTypes.node.isRequired,
  /** The left node (in LTR) */
  startNode: PropTypes.node,
  /** The right node (in LTR) */
  endNode: PropTypes.node,
};

export default FullScreenModalLayoutHeader;
